let iconVersion = ['4023669_u9dipgigbge'];
// at.alicdn.com/t/c/font_4023669_u9dipgigbge.css
let iconUrl = `//at.alicdn.com/t/c/font_$key.css`;

export {
  iconVersion,
  iconUrl
}
